import { render, staticRenderFns } from "./UpdatePasswordModal.vue?vue&type=template&id=0adb2aaa"
import script from "./UpdatePasswordModal.vue?vue&type=script&lang=js"
export * from "./UpdatePasswordModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports